export const getIndexCreatedAtTimestamp = (index: { created_at?: string }) => {
  const timestamp = index?.created_at ? new Date(index.created_at).getTime() : 0;

  return Number.isNaN(timestamp) ? 0 : timestamp;
};

export const sortIndexesNewestFirst = <T extends { created_at?: string }>(indexes: T[] = []) =>
  [...indexes].sort((a, b) => getIndexCreatedAtTimestamp(b) - getIndexCreatedAtTimestamp(a));
